import Companies from '@clearkit/icons/glyphs/Companies';
import Facebook from '@clearkit/icons/glyphs/Facebook';
import Job from '@clearkit/icons/glyphs/Job';
import Linkedin from '@clearkit/icons/glyphs/Linkedin';
import Location from '@clearkit/icons/glyphs/Location';
import Money from '@clearkit/icons/glyphs/Money';
import Tech from '@clearkit/icons/glyphs/Tech';
import Twitter from '@clearkit/icons/glyphs/Twitter';
import startCase from 'lodash/startCase';

import Group from './Group';

const CompanyEnrichment = ({ enrichment, search }) => {
  const valueForAttribute = (attribute) =>
    enrichment?.find(({ label }) => label === attribute)?.value;
  const attribute = (label) => ({ label, value: valueForAttribute(label) });

  return (
    <>
      <Group
        search={search}
        title="Company"
        icon={Companies}
        sections={[
          ['Name', 'Legal Name', 'Founded Year'].map(attribute),
          [
            'Domain',
            'Domain Aliases',
            'Parent Domain',
            'Ultimate Parent Domain',
            'Phone',
          ].map(attribute),
          [
            {
              label: 'Description',
              value: valueForAttribute('Description'),
            },
            {
              label: 'Type',
              value: startCase(valueForAttribute('Type')),
            },
          ],
          ['Employees', 'Employees Range'].map(attribute),
          ['Alexa Global Rank', 'Alexa U.S. Rank'].map(attribute),
          ['Email Provider'].map(attribute),
        ]}
      />

      <Group
        search={search}
        title={'Industry'}
        icon={Job}
        sections={[
          [
            {
              ...attribute('Industry'),
              children: ['Sector', 'Industry Group', 'Sub Industry'].map(
                attribute,
              ),
            },
          ],
          ['Tags'].map(attribute),
          [
            {
              label: 'SIC Code',
              value: valueForAttribute('SIC Code'),
              tooltip:
                'Clearbit provides the first 2 digits of SIC, representing the company sector',
            },
            {
              label: 'NAICS Code',
              value: valueForAttribute('NAICS Code'),
              tooltip:
                'Clearbit provides the first 2 digits of NAICS, representing the company sector',
            },
          ],
        ]}
      />
      <Group
        search={search}
        title="Finances"
        icon={Money}
        sections={[
          ['Annual Revenue', 'Estimated Annual Revenue'].map(attribute),
          ['Ticker', 'Market Cap'].map(attribute),
          ['Raised'].map(attribute),
          ['Fiscal Year End'].map(attribute),
        ]}
      />
      <Group
        search={search}
        title="Location"
        icon={Location}
        sections={[
          ['Location', 'Time Zone', 'UTC Offset'].map(attribute),
          [
            'Street Number',
            'Street Name',
            'City',
            'State',
            'State Code',
            'Postal Code',
            'Country',
            'Country Code',
          ].map(attribute),
          ['Latitude', 'Longitude'].map(attribute),
        ]}
      />
      <Group
        search={search}
        title="Tech"
        icon={Tech}
        sections={[
          ['Tech Categories'].map(attribute),
          [
            {
              label: 'Tech Tags',
              value: valueForAttribute('Tech')?.map((t) => startCase(t)),
            },
          ],
        ]}
      />
      <Group
        search={search}
        title="Twitter"
        type={'twitter'}
        icon={Twitter}
        sections={[
          [
            'Twitter Handle',
            'Twitter Id',
            'Twitter Followers',
            'Twitter Following',
          ].map(attribute),
        ]}
      />
      <Group
        search={search}
        title="Facebook"
        type={'facebook'}
        icon={Facebook}
        sections={[['Facebook Handle', 'Facebook Likes'].map(attribute)]}
      />
      <Group
        search={search}
        title="Linkedin"
        type={'linkedin'}
        icon={Linkedin}
        sections={[['Linkedin Handle'].map(attribute)]}
      />
    </>
  );
};

CompanyEnrichment.propTypes = {
  enrichment: PropTypes.array,
  search: PropTypes.string,
};

export default CompanyEnrichment;
